export const groupEntityWidth = (layers: Record<string, any> | undefined) => {
  if (!layers) return "100";
  const comboSettings = layers.combo?.settings || {};
  const setSettings = layers.set?.settings || {};
  const index = layers.set?.index || 0;
  const groupsRatio =
    comboSettings.groupsRatio || setSettings.groupsRatio || [];
  const width = groupsRatio[index] || "100";
  return width;
};
